import { phoneValidationYup, stringValidationYup } from "helpers/validations"
import { t } from "i18next"
import * as yup from "yup"

const getLeadValidationSchema = () =>
  yup.object().shape({
    leadType: yup.string().required(t("Lead Type is required")).nullable(),
    project: yup.object().nullable(),
    classification: yup.string().when("leadType", {
      is: value => value !== "investment",
      then: () => stringValidationYup(t("Classification is required")),
      otherwise: () => yup.string().nullable(),
    }),
    propertyType: yup.string().when("leadType", {
      is: value => value !== "investment",
      then: () => stringValidationYup(t("Property type is required")),
      otherwise: () => yup.string().nullable(),
    }),
    subType: yup.object().nullable(),
    source: yup.object().required(t("Source is required")).nullable(),
    referralSource: stringValidationYup(t("This field is required")),
    previousInteraction: yup.string().required(t("Please select an option")),
    previousInteractionNumber: phoneValidationYup(true).nullable(),
    isClientReferred: yup.string().required(t("Please select an option")),
    referralDetails: stringValidationYup(t("Referral Details are required")),
    salesEvent: yup.string().nullable().required(t("Sales Event is required")),
    allocatedTo: yup.object().nullable().required(t("Staff allocation is required")),
  })

export default getLeadValidationSchema
